export { default } from './PatientPlanTable';
